import {
  Multivenue,
  VenueTab,
  SitesBuilderLibComponent,
  Logo,
  MinisiteConfiguration,
} from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';
import { DeleteVenueComponent } from './modals/delete-venue/delete-venue.component';
import { MultivenueItemComponent } from './multivenue-item/multivenue-item.component';
import { MainVenueTab } from './models/multivenue.model';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MultivenueService } from './services/multivenue.service';

interface Interfaces {
  list: boolean;
  create: boolean;
}

@Component({
  selector: 'app-sbeditor-tool-multivenue',
  templateUrl: './multivenue.component.html',
  styleUrls: ['./multivenue.component.scss'],
})
export class MultivenueComponent implements OnInit, OnDestroy {
  public tool: Multivenue;
  private logoTool: Logo;
  //public tabs: Array<VenueTab>;
  public subscriptions: Array<Subscription>;
  private bsModalRef: BsModalRef;

  public tabs: Interfaces;
  public newVenueTab: VenueTab;
  public editVenueTabMode: boolean;
  public editVenueTab: VenueTab;
  public isDefaultTab: boolean;
  public mainVenueTab: MainVenueTab; // The default site venue, coming from site config

  public originalDVMIds: {
    venueid: string;
    mapid: string;
    minimapid: string;
  } = null;

  private site: MinisiteConfiguration = null;

  @ViewChild('multivenueItem', { static: true }) multivenueItem: MultivenueItemComponent;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private sanitization: DomSanitizer,
    private toastrService: ToastrService,
    private multivenueService: MultivenueService
  ) {
    this.subscriptions = [];
    this.tabs = {
      list: true,
      create: false,
    };
    this.newVenueTab = this.createNewTab();
  }

  ngOnInit(): void {
    console.log('Data Site: ', this.activatedRoute.snapshot.data.site);
    console.log('Data DataFlow Workflow: ', this.activatedRoute.snapshot.data.dataFlow.workflow);

    if (this.activatedRoute.snapshot.data.site) {
      this.originalDVMIds = {
        venueid: this.activatedRoute.snapshot.data.site.site.venue_code,
        mapid: this.activatedRoute.snapshot.data.site.site.map_id,
        minimapid: this.activatedRoute.snapshot.data.site.master.toolsConfig.minimap.map_id,
      };
    } else {
      this.originalDVMIds = {
        venueid: this.activatedRoute.snapshot.data.dataFlow.workflow.venue_id,
        mapid: this.activatedRoute.snapshot.data.dataFlow.workflow.map_id,
        minimapid: this.activatedRoute.snapshot.data.dataFlow.workflow.minimap_id,
      };
    }
    console.log('original DVM Ids: ', this.originalDVMIds);

    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.multivenue) {
        this.tool = Object.assign({}, res.multivenue);
        this.logoTool = Object.assign({}, res.logo);

        // Get all config logo previews
        if (this.tool.venues) {
          this.getVenueTabslogoPreviews();
        }

        console.log('Multivenue Tool: ', this.tool);
      } else {
        console.log('Multivenue tool not found');
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public onSelect($event) {
    switch ($event.target.options.selectedIndex) {
      case 0: {
        this.tool.enabled = true;
        break;
      }
      case 1: {
        this.tool.enabled = false;
        break;
      }
    }
  }

  onSwitcherChange(event: any) {
    // console.log('Is now Tool Enabled? ', this.tool.enabled);
    // console.log('Event: ', event);
    if (this.tool.enabled) {
      // Update siteData to Set Main Venue Tab
      this.updateMainVenueTab();
      this.tool.venues[0] = this.mainVenueTab;
    }
  }

  private updateMainVenueTab() {
    this.mainVenueTab = this.createNewTab();

    const siteData = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.site));

    this.mainVenueTab.venueId = this.originalDVMIds.venueid;
    this.mainVenueTab.mapId = this.originalDVMIds.mapid;
    this.mainVenueTab.minimapId = this.originalDVMIds.minimapid;

    // Logo preview
    const rootDomain = environment.sitesBuilder.staticrsc_cdn;
    if (this.logoTool && this.logoTool.default) {
      // console.log("DEFAULT");
      this.mainVenueTab.logoPreview = this.sanitization.bypassSecurityTrustUrl(
        `/ngx-sites-builder-lib-assets/img/3ddv/3ddv.png`
      );
    } else if (this.logoTool && this.logoTool.file) {
      // console.log("FILE");
      const reader = new FileReader();
      reader.readAsDataURL(this.logoTool.file);
      reader.onload = _event => {
        this.mainVenueTab.logoPreview = reader.result;
      };
    } else if (this.logoTool && this.logoTool.path) {
      // console.log("PATH");
      let parsed_url = '';
      if (siteData.master.mapConfig.client) {
        parsed_url = rootDomain + siteData.master.mapConfig.client + this.logoTool.path;
      } else {
        parsed_url = rootDomain + this.activatedRoute.snapshot.params['site'] + this.logoTool.path;
      }
      this.mainVenueTab.logoPreview = this.sanitization.bypassSecurityTrustUrl(`${parsed_url}`);
      this.mainVenueTab.path = this.logoTool.path;
    }
    // console.log("Main Tab LOGO: ", this.mainVenueTab.logoPreview);
  }

  private getVenueTabslogoPreviews() {
    if (this.activatedRoute.snapshot.data.site) {
      const siteData = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.site));
      const rootDomain = environment.sitesBuilder.staticrsc_cdn;
      for (const venue of this.tool.venues) {
        if (venue.file) {
          // console.log("FILE");
          const reader = new FileReader();
          reader.readAsDataURL(venue.file);
          reader.onload = _event => {
            venue.logoPreview = reader.result;
          };
        } else if (venue.path) {
          // console.log("PATH");
          let parsed_url = '';
          if (siteData.master.mapConfig.client) {
            parsed_url = rootDomain + siteData.master.mapConfig.client + venue.path;
          } else {
            parsed_url = rootDomain + this.activatedRoute.snapshot.params['site'] + venue.path;
          }
          venue.logoPreview = this.sanitization.bypassSecurityTrustUrl(`${parsed_url}`);
        }
        // console.log('Venue Tab (getting logo Preview): ', venue);
      }
    }
  }

  public toggleInterface(tab: string) {
    let createNewTab = true;
    if (this.tabs.create && tab === 'create') {
      createNewTab = false;
    }
    switch (tab) {
      case 'list':
        this.tabs = {
          list: true,
          create: false,
        };
        break;
      case 'create':
        this.tabs = {
          list: false,
          create: true,
        };
        this.editVenueTab = null;
        break;
      default:
        break;
    }
  }

  public onSelectPosition($event) {
    switch ($event.target.options.selectedIndex) {
      case 0: {
        this.tool.position = 'lateral';
        break;
      }
      case 1: {
        this.tool.position = 'top';
        break;
      }
    }
    this.apply();
  }

  public toggleEditVenueTabMode(venueTab: VenueTab, defaultConfig: boolean) {
    if (this.editVenueTab && venueTab.id !== this.editVenueTab.id) {
      this.editVenueTabMode = true;
    } else {
      this.editVenueTabMode = !this.editVenueTabMode;
    }
    this.editVenueTab = Object.assign({}, venueTab);
    this.isDefaultTab = defaultConfig;
  }

  public deleteVenueTab(venueTab: VenueTab) {
    const modalConfig: ModalOptions = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
    };
    this.bsModalRef = this.modalService.show(DeleteVenueComponent, modalConfig);
    this.bsModalRef.onHide.subscribe(response => {
      if (this.bsModalRef.content.closeReason == 'success') {
        this.tool.venues = this.tool.venues.filter(venue => {
          return venue.id !== venueTab.id;
        });
        this.apply();
      }
    });
  }

  public onEditVenueTab($event: VenueTab) {
    this.tool.venues = this.tool.venues.map(i => {
      if (i.id === $event.id) {
        i = Object.assign({}, $event);
      }
      return i;
    });
    this.apply();
    this.editVenueTabMode = false;
  }

  public onCreateVenueTab($event: VenueTab) {
    let venueTab = Object.assign({}, $event);
    this.tool.venues.push(venueTab);
    this.apply();
    this.tabs.list = true;
    this.tabs.create = false;
    this.newVenueTab = this.createNewTab();
    // console.log('New Venue Tab: ', this.newVenueTab);
  }

  public changeOrder(venueTab: VenueTab, direction: string) {
    let oldIndex = this.tool.venues.indexOf(venueTab);
    if (direction === 'up' && oldIndex !== 0) {
      // Si se quiere mover arriba y no es la segunda (la primera está fijada y no se mueve)
      this.tool.venues.splice(oldIndex, 1);
      this.tool.venues.splice(oldIndex - 1, 0, venueTab);
    } else if (direction === 'down' && oldIndex !== this.tool.venues.length - 1) {
      // Si se quiere mover abajo y no es la última
      this.tool.venues.splice(oldIndex, 1);
      this.tool.venues.splice(oldIndex + 1, 0, venueTab);
    }
  }

  private apply() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.multivenue = Object.assign({}, this.tool);
      console.log('tools before apply: ', res);

      this.sblibService.apply(res);
      this.toastrService.success('', 'Changes applied');
    });
    this.subscriptions.push(tools$);
  }

  private generateRandomId() {
    let result = '';
    const characters = 'ABCD0123';
    const length = 6;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return 'M' + result;
  }

  public createNewTab(): VenueTab {
    let newTab: VenueTab;
    return (newTab = {
      id: this.generateRandomId(),
      venueId: '',
      mapId: '',
      minimapId: '',
      file: null,
      path: '',
      name: '',
      logoPreview: null,
      type: 'icon',
    });
  }

  public checkBeforeApply() {
    if (!this.tool.enabled) {
      this.tool = {
        enabled: false,
        position: 'lateral',
        venues: [],
      };
    }
    if (this.editVenueTab) {
      this.tool.venues = this.tool.venues.map(v => {
        if (v.id === this.editVenueTab.id) {
          v = this.editVenueTab;
        }
        return v;
      });
    }

    if (this.newVenueTab && this.multivenueService.validateNewItem(this.newVenueTab)) {
      this.tool.venues.push(this.newVenueTab);
    }

    this.tabs.list = true;
    this.tabs.create = false;
    this.apply();
    this.newVenueTab = this.createNewTab();
  }
}
